import axios from "axios";
import encrypt from "./src/encrypt";
import base64_decoder_interceptor from "./src/base64-decoder";
import forge from 'node-forge';

let publicKey;
let csrfToken;

let keyPair = {
    privateKey: null,
    publicKey: null
};

const generateFormData = function (data, encrypted_fields) {
    const bodyFormData = new FormData();
    let needEncrypt = false;
    for (let [key, value] of Object.entries(data)) {
        needEncrypt = false;
        if (publicKey) {
            if (encrypted_fields === "all") {
                needEncrypt = true;
            } else if (encrypted_fields.indexOf(key) >= 0) {
                needEncrypt = true;
            }
        }

        if (needEncrypt) {
            value = encrypt(value, publicKey);
        }

        if (Array.isArray(value)) {
            const length = value.length;
            let i;
            for (i = 0; i < length; i += 1) {
                bodyFormData.append(key, value[i]);
            }
        } else {
            bodyFormData.append(key, value);
        }
    }

    return bodyFormData;
};

const form = function (url, data, encrypted_fields = []) {
    const bodyFormData = generateFormData(data, encrypted_fields);

    return axios({
        method: 'post',
        url: url,
        data: bodyFormData,
        headers: {'Content-Type': 'multipart/form-data'}
    });
};

const install = function (Vue, options) {
    forge.pki.rsa.generateKeyPair(1024, function (err, {privateKey, publicKey}) {
        keyPair.publicKey = publicKey;
        keyPair.privateKey = privateKey;
    });

    let onRejected = function (error) {
        return Promise.reject(error);
    };

    axios.interceptors.response.use(
        base64_decoder_interceptor,
        onRejected
    );

    axios.interceptors.response.use(function (response) {
        let json = response.data;
        const sPublicKey = json['public-key'];
        if (sPublicKey) {
            publicKey = sPublicKey;
        }

        return response;
    }, onRejected)

    axios.interceptors.response.use(function (response) {
        let headers = response.headers;
        let token = headers['x-csrf-token'];
        if (token) {
            csrfToken = token;
        }
        return response;
    }, onRejected)

    axios.interceptors.request.use(req => {
        req.headers['x-csrf-token'] = csrfToken
        return req;
    });
}

export default {
    install,
    form,

    axios: axios,

    interceptors: axios.interceptors,
    get: axios.get,
    post: axios.post,
    
    setPublicKey(sKey) {
        publicKey = sKey;
    }
};
